 export interface IDonorStatusChangeRequest {
    chainId: number;
    clusterNumber: number;
    positionNumber: number;
    donorStatus: number;
}
